export default "__VITE_ASSET__DylTu34Y__"